import PopupList from '@forms/Components/Dropdowns/List';
import { useFormikContext, Field } from 'formik';
import { FormikButtonDropdown } from '../Components/Dropdowns/ButtonDropdown';
import { ReportItem } from '../../Reports/types';

import styles from '../Components/Form.module.css';

interface ReportDropdownProps {
  fieldName: string;
  className?: string;
  reports: ReportItem[];
}

export default function ReportDropdownField(props: ReportDropdownProps) {
  const { getFieldMeta, setFieldValue, setFieldTouched } = useFormikContext();
  const { value } = getFieldMeta<string>(props.fieldName);

  return (
    <Field
      name={props.fieldName}
      component={FormikButtonDropdown({
        ButtonContent: () => {
          const selected = props.reports.find((r) => r.code === value);
          return <span>{selected ? selected.name : 'Select Report'}</span>;
        },
        buttonContentProps: {},
        PopupContent: PopupList,
        popupContentProps: {
          items: props.reports,
          getItemDisplay: (item: ReportItem) => item.name,
          onItemSelect: (selected: ReportItem) => {
            void setFieldTouched(props.fieldName, true);
            void setFieldValue(props.fieldName, selected.code, true);
          },
          className: styles['list-box-md']
        }
      })}
      className={props.className}
    />
  );
}
